import React from 'react'

function ViewTypeField(props) {
  const {
    viewType,
    onViewTypeSelect,
    childViewType
  } = props

  return (
      <select
          value={viewType}
          onChange={(e) => onViewTypeSelect(e)}
          className="form-control select-lg mb-3"
          style={{fontSize: '14px'}}
      >
        <option value={viewType}>List by {viewType}</option>
        <option value={childViewType}>List by {childViewType}</option>
      </select>)
}

export default ViewTypeField
